import React, { useEffect, useRef } from 'react'
import { ClickAwayListener, Menu } from '@mui/material'
import { mediaPermissionPrompt } from '../../../../utils/browserUtils';
import './MediaControlMenu.css'
import disponible from "../../../../assets/disponible.png"
import { tenantHasFeature } from '../../../Auth/utils/AuthUtils';
export default function MediaControlMenu({
    isOpen = false,
    deviceType,
    headerIcon,
    headerText,
    selectedDevice,
    devices,
    handleDeviceSelection,
    deviceActive,
    devicePermission,
    selectedIcon = disponible,
    onClickAway,

    settingsButtonLabel,
    handleSettingsClick,


    // Camera effects exceptional state
    isVideoMenu,
    selectedEffect,
    effectEnabled,
    handleSelectEffect,
    /*  effectList: [{label: string , icon : string, callback: function}] */
    effectList,

    
}) {

    /*------------RENDERING------------ */
    return (
        <>
            {isOpen && (
                <ClickAwayListener onClickAway={onClickAway}  >
                    <div className="config-devices">
                        <div>
                            <span className="title-dropdown">
                                <span className="material-symbols-outlined">
                                    {headerIcon}
                                </span>
                                <span className="media-control-header-text">
                                    {headerText}
                                </span>
                            </span>
                            {devices?.length > 0 && (
                                <ul className="device-item">
                                    {devices.map((device) => (
                                        <li key={device.deviceId} value={device.deviceId} onClick={() => {
                                            handleDeviceSelection(device)
                                        }}>
                                            <span className="device-label" title={device.label || `${deviceType} ${device.deviceId}`} >{device.label || `${deviceType} ${device.deviceId}`}</span>
                                            {selectedDevice.deviceId === device.deviceId ?
                                                <span className="w-24 selected-flag" alt="Selected device"></span> :
                                                null
                                            }
                                        </li>
                                    ))}
                                </ul>
                            )}

                            {(effectList?.length > 0 && isVideoMenu && tenantHasFeature("CAMERA_EFFECT_ENABLED") && deviceActive) && (
                                <div>
                                    <span className="title-dropdown">
                                        <span className="material-symbols-outlined">
                                            wand_stars
                                        </span>
                                        Selectionne un effet
                                    </span>
                                    {
                                        effectList.map((effect, index) => (
                                            <>
                                                <span className="effect-camera" onClick={() => handleSelectEffect(effect?.id)}>
                                                    <span className="material-symbols-outlined">
                                                        {effect?.icon}
                                                    </span>
                                                    {effect?.label}
                                                    {selectedEffect === effect.id ?
                                                        <span className="w-24 selected-flag" alt="Camera effect"></span> :
                                                        null
                                                    }
                                                </span>
                                            </>

                                        ))}
                                </div>)
                            }

                            <div className="mt-15 config-audio-video" onClick={handleSettingsClick}>
                                {settingsButtonLabel}
                            </div>
                        </div >
                    </div >
                </ClickAwayListener>
            )}
        </>
    )
}
